












import Vue from 'vue';
import isGranted from '../../auth/isGranted';
import recognition from '../../auth/recognition';
import SubscribeUnsubscribeAction from './SubscribeUnsubscribeAction.vue';
import SubscribedUsersList from './SubscribedUsersList.vue';

export default Vue.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Subscribers',
    },
  },
  computed: {
    isClient(): boolean {
      return recognition.isClient();
    },
  },
  methods: {
    isGranted,
  },
  components: {
    SubscribeUnsubscribeAction,
    SubscribedUsersList,
  },
});
